/*
THIS COMPONENT INCLUDING IN COMPENSATION PAGE
 ---------------------------------------------*/

let Compensation = (() => {
    let privateHouseCheckBox = '#is_private_house';
    let departureInput = '#departure_type';
    let statusSelect = '#status_id';
    let fillButton = '#fill-button';
    let url = '/shop/orders/';
    let $orderInput = $('#order_number');
    let $form = $('#compensation_form');
    const isFirstClass = 1;
    const requiredStatuses = [2, 3];
    const isPostBox = 3;

    let init = () => {
        checkValidation();

        listenFillButton();
        listenChangeStatus();
        listenChangeDepartureType();
        listenChangeIsPrivateHouse();
    };

    let listenFillButton = () => {
        $(document).on('click', fillButton, () => {
            fillFields();
        });
    };

    let listenChangeStatus = () => {
        $(document).on('change', statusSelect, function () {
            checkValidation();
        });
    };

    let listenChangeDepartureType = () => {
        $(document).on('change', departureInput, function () {
            checkValidation();
        });
    };

    let listenChangeIsPrivateHouse = () => {
        $(document).on('change', privateHouseCheckBox, function () {
            checkValidation();
        });
    };

    let fillFields = () => {
        let order_number = $orderInput.first().val();
        if (isEmptyString(order_number)) {
            alert('Укажите номер заказа');
            return;
        }

        loadOrder(order_number);
    };

    let isEmptyString = (str) => {
        return (!str || str.length === 0 || str === 'undefined')
    };

    let loadOrder = (order_number) => {
        $.ajax({
            url: url + order_number,
            method: 'GET'
        }).done((order) => {
            fillFieldsByOrder(order);
        });
    };

    let fillFieldsByOrder = (order) => {
        $form.find('#lastname').first().val(order.lastname);
        $form.find('#firstname').first().val(order.firstname);
        $form.find('#patronymic').first().val(order.patronymic);
        $form.find('#email').first().val(order.email);
        $form.find('#phone').first().val(order.phone);
        $form.find('#region_id').first().val(order.region_id);
        $form.find('#city').first().val(order.city);
        $form.find('#postcode').first().val(order.postcode);
        $form.find('#street').first().val(order.street);
        $form.find('#house').first().val(order.house);
        $form.find('#is_private_house').first().val(order.is_private_house);
        $form.find('#apartment').first().val(order.apartment);
        $form.find('#housing').first().val(order.housing);
        $form.find('#building').first().val(order.building);
        $form.find('#postbox_number').first().val(order.postbox_number);
    };

    let checkValidation = () => {

        let checkedDeparture = $(departureInput).val();
        let isRequiredStatus = checkedRequiredStatus();
        toggleCommonFields(isRequiredStatus);
        toggleDepartureFields(checkedDeparture, isRequiredStatus);
    };

    let checkedRequiredStatus = () => {
        let status_id = Number($form.find('#status_id').first().val());
        return requiredStatuses.includes(status_id);
    };

    let toggleCommonFields = (isShouldBeRequired) => {
        $form.find('#region_id').first().prop('required', isShouldBeRequired);
        $form.find('#city').first().prop('required', isShouldBeRequired);
        $form.find('#postcode').first().prop('required', isShouldBeRequired);
        $form.find('#email').first().prop('required', isShouldBeRequired);

        $form.formValidation('enableFieldValidators', 'region_id', isShouldBeRequired);
        $form.formValidation('enableFieldValidators', 'city', isShouldBeRequired);
        $form.formValidation('enableFieldValidators', 'postcode', isShouldBeRequired);
        $form.formValidation('enableFieldValidators', 'email', isShouldBeRequired);
    };

    let toggleDepartureFields = (departureTypeId, isRequiredStatus) => {
        setAddressValidation(departureTypeId, isRequiredStatus);
        setFioValidation(departureTypeId, isRequiredStatus);
    };

    let setAddressValidation = (departureTypeId, isRequiredStatus) => {
        let isShouldBeRequired = isRequiredStatus && Number(departureTypeId) === isFirstClass;

        $form.find('#street').first().prop('required', isShouldBeRequired);
        $form.find('#house').first().prop('required', isShouldBeRequired);

        $form.formValidation('enableFieldValidators', 'street', isShouldBeRequired);
        $form.formValidation('enableFieldValidators', 'house', isShouldBeRequired);

        setApartmentValidation(isShouldBeRequired);
    };

    let setApartmentValidation = (isShouldBeRequired) => {
        let isPrivateHome = $form.find('#is_private_house').prop("checked");
        isShouldBeRequired = isShouldBeRequired && !isPrivateHome;

        $form.find('#apartment').first().prop('required', isShouldBeRequired);
        $form.formValidation('enableFieldValidators', 'apartment', isShouldBeRequired);
    };

    let setFioValidation = (departureTypeId, isRequiredStatus) => {
        let isShouldBeRequired = isRequiredStatus && Number(departureTypeId) !== isPostBox;

        $form.find('#lastname').first().prop('required', isShouldBeRequired);
        $form.find('#firstname').first().prop('required', isShouldBeRequired);
        $form.find('#patronymic').first().prop('required', isShouldBeRequired);

        $form.formValidation('enableFieldValidators', 'lastname', isShouldBeRequired);
        $form.formValidation('enableFieldValidators', 'firstname', isShouldBeRequired);
        $form.formValidation('enableFieldValidators', 'patronymic', isShouldBeRequired);
    };

    return {
        init: init
    }
})();

export default Compensation;
